import { makeKey, update } from "../../../../utils/reducerOperations";
export function changeFirstLastNameStarted(state, payload) {
  return makeKey(
    "changeFirstLastNameApi",
    update(state.changeFirstLastNameApi, { isProcessing: true })
  );
}
